import './styles/App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import AnnouncementBar from './components/AnnouncementBar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import EventPackages from './pages/EventPackages';
import Products from './pages/Products';
import Connections from './pages/Connections';
import ContactUs from './pages/ContactUs';
import Cart from './pages/Cart';
import TermsAndConditions from './pages/TermsAndConditions';
import NotFound from './pages/NotFound';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';

// Admin imports
import AdminLayout from './components/admin/AdminLayout';
import AdminRoute from './components/admin/AdminRoute';
import AdminLogin from './pages/admin/AdminLogin';
import Dashboard from './pages/admin/Dashboard';
import AdminProducts from './pages/admin/Products';
import AdminOrders from './pages/admin/Orders';
import AdminServices from './pages/admin/AdminServices';
import AdminUsers from './pages/admin/Users';
import AdminSettings from './pages/admin/Settings';

function AppContent() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        {/* Admin Routes - Completely separate from user site */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin"
          element={
            <AdminRoute>
              <AdminLayout />
            </AdminRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="products" element={<AdminProducts />} />
          <Route path="orders" element={<AdminOrders />} />
          <Route path="services" element={<AdminServices />} />
          <Route path="users" element={<AdminUsers />} />
          <Route path="settings" element={<AdminSettings />} />
        </Route>

        {/* User Routes - Regular site (no login required) */}
        <Route
          path="/*"
          element={
            <CartProvider>
              <div className="App">
                <Navbar />
                <AnnouncementBar />
                <main>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/services" element={<Services />} />
                    <Route path="/services/:serviceName" element={<ServiceDetail />} />
                    <Route path="/event-packages" element={<EventPackages />} />
                    <Route path="/products" element={<Products />} />
                    <Route path="/connections" element={<Connections />} />
                    <Route path="/contact" element={<ContactUs />} />
                    <Route path="/cart" element={<Cart />} />
                    <Route path="/profile" element={<Navigate to="/" replace />} />
                    <Route path="/orders" element={<Navigate to="/" replace />} />
                    <Route path="/favorites" element={<Navigate to="/" replace />} />
                    <Route path="/terms" element={<TermsAndConditions />} />
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                </main>

                <Footer />
              </div>
            </CartProvider>
          }
        />
      </Routes>
    </Router>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
